<div class="mbway-payment d-flex justify-content-center">
    <i class="btn-close icon-edponline-Bop-071" (click)="closeModal()"  aria-hidden="true"></i>
    <ng-template #errorUserReason>
        <edp-payment-user-feedback-modal [data]="payment"></edp-payment-user-feedback-modal>
    </ng-template>
    <ng-container *ngIf="!showOpenBankingErrorUserReason; else errorUserReason">
        <div class="info-panel">
            <div class="icon  {{statusClass}}">
                <i class="{{actionIcon}}"  aria-hidden="true"></i>
            </div>
            <div class="status {{statusClass}}">{{paymentStatus | translate | edpCapitalize }}</div>
            <div class="info" [innerHTML]="infoMsg"></div>
            <div *ngIf="statusClass === 'pending'" class="info" [innerHTML]="infoReopenUrl"></div>
            <!--BEGIN DESKTOP-->
            <div *ngIf="statusClass === 'pending'" class="d-none d-sm-block">
                <div class="payment-data">
                    <div *ngIf="paymentType === 'MBWAY'" class="mobile-number">
                        {{'pt.edp.edponline.mbway.modal.pendente.phone' | translate}} <span>{{payment.phone}}</span></div>
                    <div *ngIf="paymentType === 'OPENBANKING'" class="mobile-number">
                        {{'pt.edp.edponline.payment.modal.bank' | translate}} <span>{{payment.bankName}}</span></div>
                    <div class="amount">{{'pt.edp.edponline.mbway.modal.pendente.amount' | translate}}
                        <span>{{payment.amount}}€</span></div>
                </div>
                <div *ngIf="paymentType === 'MBWAY'" class="cancel-info"
                    [innerHTML]="'pt.edp.edponline.mbwaypayment.want.to.cancel' | translate">
                    <a class="but button">{{'pt.edp.edponline.mbwaypayment.cancel.payment' | translate}}</a>
                </div>
            </div>
            <!--END DESKTOP-->
            <!--BEGIN MOBILE-->
            <div *ngIf="statusClass === 'pending'" class="d-sm-none">
                <div class="d-flex">
                    <div class="payment-data">
                        <div *ngIf="paymentType === 'MBWAY'" class="mobile-number">
                            {{'pt.edp.edponline.mbway.modal.pendente.phone' | translate}}</div>
                        <div *ngIf="paymentType === 'OPENBANKING'" class="mobile-number">
                            {{'pt.edp.edponline.payment.modal.bank' | translate}}</div>
                        <div>{{ (paymentType === 'MBWAY')? payment.phone : payment.bankName }}</div>
                        <div class="mt-2 amount">{{'pt.edp.edponline.mbway.modal.pendente.amount' | translate}}</div>
                        <div>{{payment.amount}}€</div>
                    </div>
                    <div class="timer-panel">
                        <ng-container *ngTemplateOutlet="progressTemplate"></ng-container>
                    </div>
                </div>
                <div *ngIf="paymentType === 'MBWAY'" class="cancel-info" [innerHTML]="'pt.edp.edponline.mbwaypayment.want.to.cancel' | translate">
                    <a class="but button">{{'pt.edp.edponline.mbwaypayment.cancel.payment' | translate}}</a>
                </div>
            </div>
            <!--END MOBILE-->
            <div *ngIf="statusClass !== 'pending'" class="cancel-info">
                <a class="but button edp-text-seaweed-green" (click)="closeModal('payments')"> <span class="d-none">&lt;</span>
                    {{'pt.edp.edponline.mbway.modal.go.to.payments.page' | translate}}</a>
            </div>
        </div>
        <div *ngIf="statusClass === 'pending'" class="d-none d-sm-block timer-panel">
            <ng-container *ngTemplateOutlet="progressTemplate"></ng-container>
        </div>
    </ng-container>
</div>

<ng-template #progressTemplate>
    <circle-progress [percent]="progress" [radius]="100" [outerStrokeWidth]="10" [innerStrokeWidth]="10" [space]="-10"
        [outerStrokeColor]="'#263CC8'" [innerStrokeColor]="'#F1F4F4'" [titleFontSize]="45" [showSubtitle]="false"
        [animation]="true" [animationDuration]="300" [startFromZero]="false" [responsive]="true" [title]="title"
        [showUnits]="false" [toFixed]="2" [titleColor]="'#263CC8'">
    </circle-progress>
</ng-template>